import { useQuery } from '@tanstack/react-query';
import { api } from './api-client';
import { useTimesheetVisibility } from './useTimesheetVisibility';
import type { MyReminderStatusDto } from './types';

// The signed-in employee's own timesheet reminder standing, shared by the home banners and the
// time-off booking notice (same key = one cache entry, one request). Gated on timesheet
// visibility so the poll never fires while timesheets are hidden from this user; the endpoint
// itself never 403s and answers the empty DTO for out-of-scope callers anyway.
export function useReminderStatus() {
  const visibility = useTimesheetVisibility();
  return useQuery({
    queryKey: ['timesheet', 'reminder-status'],
    queryFn: () => api.get<MyReminderStatusDto>('/v1/timesheet/reminders/my-status'),
    staleTime: 5 * 60_000,
    enabled: visibility.data?.canView === true,
  });
}
